import React, { useEffect, useState } from 'react';
import { AlertTriangle } from 'lucide-react';
import { getMovementsByJob } from '../../redux/api';
import {
  getOpenWithdrawnMovements,
  getWithdrawnMovementLabel,
  WITHDRAWN_STATUS_LABELS,
} from '../../utils/withdrawnItemsUtils';

const WithdrawnItemsReminderBanner = ({
  jobId,
  variant = 'worker',
  className = '',
}) => {
  const [movements, setMovements] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!jobId) {
      setMovements([]);
      return;
    }
    let cancelled = false;
    const load = async () => {
      try {
        setLoading(true);
        const response = await getMovementsByJob(jobId);
        if (!cancelled) {
          setMovements(response.data || []);
        }
      } catch (error) {
        if (!cancelled) setMovements([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    load();
    return () => {
      cancelled = true;
    };
  }, [jobId]);

  const openMovements = getOpenWithdrawnMovements(movements);
  if (loading || openMovements.length === 0) return null;

  const isAdmin = variant === 'admin';
  const count = openMovements.length;

  return (
    <div
      className={`rounded-md border border-amber-600/50 bg-amber-950/40 px-3 py-2 ${className}`}
      role="status"
    >
      <div className="flex gap-2">
        <AlertTriangle className="h-4 w-4 text-amber-400 shrink-0 mt-0.5" />
        <div className="min-w-0 flex-1 space-y-1">
          <p className="text-xs font-medium text-amber-100">
            {count === 1 ? '1 otvorena stavka robe' : `${count} otvorene stavke robe`}
          </p>
          <ul className="space-y-0.5">
            {openMovements.map((movement) => (
              <li key={movement._id} className="text-[11px] text-amber-100/90 truncate">
                {getWithdrawnMovementLabel(movement)}
                {' · '}
                {movement.quantity} {movement.unit || 'kom'}
                {' · '}
                {WITHDRAWN_STATUS_LABELS[movement.status] || movement.status}
              </li>
            ))}
          </ul>
          <p className="text-[11px] text-amber-200/80">
            {isAdmin ? 'Označi iskorišćeno ili vrati.' : 'Ako nije ugrađeno, javi adminu.'}
          </p>
        </div>
      </div>
    </div>
  );
};

export default WithdrawnItemsReminderBanner;
